import React from 'react';

import Map from '../Map/Map';

/**
 * A minimal page that renders only the map component.
 * `mapOnly` is a supported public platform, not a development or testing aid:
 * it is one of PUBLIC_PLATFORMS in src/utils/publicPlatforms.js, and resolved
 * from the URL in AppHelpers.js.
 * Access via: /map-only
 */
const MapOnlyPage = () => (
  <div
    className="map"
    style={{
      width: '100vw',
      height: '100vh',
      position: 'fixed',
      top: 0,
      left: 0,
    }}
  >
    <Map />
  </div>
);

export default MapOnlyPage;
